import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-3xl font-semibold mb-4">Privacy Policy</h1>
            <p className="text-gray-700 mb-4">
                At <span className="font-semibold">Academy-nest.com</span>, your privacy is of utmost importance to us. This Privacy Policy outlines how we collect, use, and safeguard your personal information while you use our platform.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                    <span className="font-semibold">Personal Information:</span> When you register, we collect details such as your name, email address, and payment information.
                </li>
                <li>
                    <span className="font-semibold">Course Activity:</span> We track the courses you enroll in, your progress, and your participation in live sessions.
                </li>
                <li>
                    <span className="font-semibold">Device and Usage Data:</span> We gather data like IP addresses, browser type, and usage patterns to improve your experience.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>To deliver the courses and services you sign up for.</li>
                <li>To provide personalized recommendations and content.</li>
                <li>To ensure the security and integrity of our platform.</li>
                <li>To communicate updates about courses, billing, and promotions.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">3. Sharing Your Information</h2>
            <p className="text-gray-700">
                We do not sell or rent your personal information to third parties. However, we may share data with trusted service providers to help us operate our platform (e.g., payment processors) or comply with legal obligations.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">4. Security Measures</h2>
            <p className="text-gray-700">
                We use encryption, secure servers, and other best practices to protect your data. While we strive to safeguard your information, no system is completely secure.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">5. Your Rights</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>Access, update, or delete your personal information at any time through your account settings.</li>
                <li>Opt-out of promotional emails by using the unsubscribe link provided in our emails.</li>
                <li>Contact us if you have questions about how your data is used.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">6. Changes to This Policy</h2>
            <p className="text-gray-700">
                We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We encourage you to review this page periodically.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">7. Contact Us</h2>
            <p className="text-gray-700">
                If you have any questions or concerns about this Privacy Policy, please contact us at{" "}
                <a href="mailto:support@academy-nest.com" className="text-blue-500 hover:underline">
                    support@academy-nest.com
                </a>.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
